import gql from "graphql-tag";
import {PaxNodeComplianceAuthorizationFieldsFragment, PaxNodeComplianceFieldsFragment} from "./Compliance";

export const LivePaxNodeFragment = gql`
    fragment LivePaxNodeFragment on PaxNode {
        ...PaxNodeComplianceFieldsFragment,
        lastName,
        firstName,
        personID {
            _id
            extraBroadState
        }
        customerID {
            _id
            name
        }
        employerID {
            _id
            name
        },
        contractorID
        contractorDoc {
            _id
            name
        }
        tpID {
            _id
            name
        }
        paxWeight,
        bagWeight,
        checkInType,
        bagCount,
        checkedInTime,
        scheduledFlightDate,
        destinationID {
            _id, name
        }
        departureID {
            _id, name
        },
        transitType
        authorization {
            onWhiteList
            noFlyListed
            ...PaxNodeComplianceAuthorizationFieldsFragment,
            brdRestriction_SafetyCard {
                status
            }
            brdRestriction_HuetCard {
                status
            }
            brdRestriction_SteelToes {
                status
            }
            brdRestriction_Twic {
                status
            }
            brdRestriction_NonPreferred {
                status
            }
            brdRestriction_Hazmat {
                status
            }
            brdRestriction_NoFlyListed {
                status
            }
            brdRestriction_EbsCard {
                status
            }
            brdRestriction_Illness {
                status
            }
            brdRestriction_Quarantined {
                status
            }
        }
        currentCarrierID {
            _id
            desig
            state
        }
    }
    ${PaxNodeComplianceFieldsFragment}
    ${PaxNodeComplianceAuthorizationFieldsFragment}
`